import { render, staticRenderFns } from "./PriceStandardComponent.vue?vue&type=template&id=70a6a1ac&scoped=true&"
import script from "./PriceStandardComponent.vue?vue&type=script&lang=js&"
export * from "./PriceStandardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a6a1ac",
  null
  
)

export default component.exports